<script setup lang="ts">
withDefaults(defineProps<{
  title?: string
  isLoading?: boolean
  error?: Error | null
  size?: 'small' | 'medium' | 'large' | 'huge'
}>(), {
  title: undefined,
  isLoading: false,
  error: undefined,
  size: 'medium',
})
</script>

<template>
  <n-card :title="title" :size class="bg-white" :segmented="true">
    <template #header>
      <slot name="headerMain" />
    </template>
    <template #header-extra>
      <slot name="headerExtra" />
    </template>

    <slot name="header" />
    <slot name="controls" />
    <n-skeleton
      v-if="isLoading"
      class="rounded"
      height="20vh"
      width="100%"
      :sharp="false"
    />
    <template v-else-if="error">
      Ein Fehler ist aufgetreten, versuchen Sie es später erneut ({{ error || 'N/A' }})
    </template>
    <template v-else>
      <slot name="summary" />
      <slot />
    </template>
  </n-card>
</template>

<style scoped>
:deep(.n-card-header) {
  @apply flex-wrap justify-between gap-2;
}
:deep(.n-card-header .n-card-header__main) {
  @apply text-text font-semibold break-normal;
  flex: initial;
  min-width: initial;
}
</style>
